<br>

<div style="width: auto; overflow: auto">
    <app-common-list-table
        [request]='getRequest'
        [cols]='cols'
        [filtering]='filter'
        actionButtonText="Añadir entidad" 
        (actionButtonClick)="add()"
        [globalVisualTransform]='globalVisualTransform'
        [globalConditionalStyle]='globalConditionalStyle'>

        <ng-template #thEnd>
          
            <th>
                <p class="d-flex justify-content-center" style="margin-bottom: 0">Acciones</p>
            </th>
         
           
        </ng-template>

        <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
            <td>
                <app-action-buttons
                    [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                    (duplicateRowButtonEvent)="duplicate(data.data)"
                    (editRowButtonEvent)="edit(data.data)"
                    (deleteRowButtonEvent)="show('delete', data.data)"
                    (showRowButtonEvent)="show('info', data.data)">
                </app-action-buttons>
            </td>
        
         
        </ng-template>
    </app-common-list-table>
</div>


<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="true"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>

